import './AddGoal.css';
// import TimeConstraintSelection from '../components/TimeConstraintSelection.js'
import Selector from '../components/Selector.js'
import AddMilestone from './milestones/AddMilestone.js'
import Milestone from './milestones/Milestone.js'
import updateUserData from '../../assets/functions/updateUserData'
import React, {useState} from "react";

function AddGoal(props) {

    const [description, setDescription] = useState("");
    // const [timeConstraintType, setTimeConstraintType] = useState("");
    // const [timeConstraintTime, setTimeConstraintTime] = useState("");
    const [goalType, setGoalType] = useState("milestone");
    const [milestones, setMilestones] = useState([]);
    const [isGlowGoal, setIsGlowGoal] = useState(false)
    const [projectId, setProjectId] = useState("")

      const handleNoteChange = (event) => {
        setDescription(event.target.value);
      };

      function clearFormData() {
        props.setShowAddGoal(false)
      }

    return (
        <div className="addGoalOuterBlock">
          <p className="cancelText" onClick={() => props.setShowAddGoal(false)}> cancel</p>
            <div className="goalTypeRow">
              <p onClick={() => setGoalType("milestone")} className={goalType==="milestone" ? "goalType activeGoalType" : "goalType"}> milestone </p>
              <p onClick={() => setGoalType("routine")} className={goalType==="routine" ? "goalType activeGoalType" : "goalType"}> routine </p>
            </div>
            <div className="goalProjectSelector">
              <div className="addGoalProjectSelector">
                                {!isGlowGoal &&
                <Selector setData={setProjectId} userProfile={props.userProfile} header="select associated project" type="projects" className="dropdownContainer"/>
              }
              {isGlowGoal &&
                <Selector setData={setProjectId} userProfile={props.userProfile} header="select associated project" type="glowGoals" className="dropdownContainer"/>
              }
              </div>
                <div className="goalGlowPower">
                    <p onClick={() => setIsGlowGoal(true)} className={isGlowGoal ? "glowPowerGoal activeGlowGoalButton" : "glowPowerGoal"}> glow </p>
                    <p onClick={() => setIsGlowGoal(false)} className={isGlowGoal ? "glowPowerGoal" : "glowPowerGoal activePowerGoalButton"}> power </p>
                </div>
            </div>
            <div className="goalDescriptionDiv">
                <p className="goalTextHeader">set goal description</p>
                <textarea
                    className="goalDescriptionInput"
                    type="text"
                    id="description"
                    value={description}
                    onChange={handleNoteChange}
                    name="description"
                    spellCheck="false"
                />
            </div>
            {/* <div className="goalTimeConstraintSection">
                <TimeConstraintSelection shrunk={true} timeConstraintType={timeConstraintType} timeConstraintTime={timeConstraintTime} setTimeConstraintType={setTimeConstraintType} setTimeConstraintTime={setTimeConstraintTime} />
            </div> */}
            {goalType === "milestone" && 
              <div className="milestonesRowFlex">
                        {milestones.map((milestone, index) => (
                            <Milestone key={index} index={index} milestone={milestone}/>
                        ))}
                        <AddMilestone milestones={milestones} setMilestones={setMilestones}/>
                    </div>
            }
            {goalType === "routine" && 
              <div className="routineInput">
                <p> routine </p>
            </div>
            }
            <p className="doneButtonAddGoal" onClick={async () => 
              {updateUserData("goal", 
                {"goalType": goalType, "title": description, "milestones": milestones, "timeConstraintType": "", "timeConstraintTime": "",  "projectId": projectId, "isGlowGoal": isGlowGoal},
                props.userProfile,
                props.setUserProfile,
                clearFormData
                )} }> add goal</p>
        </div>
    )
}

export default AddGoal;